export const LayoutGridOneColumn = () => (
	<svg
		width="17px"
		height="20px"
		viewBox="0 0 17 20"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>layout-modern</title>
		<desc>Created with Sketch.</desc>
		<g
			id="Desktop-0.4"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="widgets/layout-modern"
				transform="translate(-2.000000, -3.000000)"
				fill="#000000"
			>
				<path
					d="M2,10 L5,10 L5,7 L2,7 L2,10 Z M2,14 L5,14 L5,11 L2,11 L2,14 Z M2,6 L5,6 L5,3 L2,3 L2,6 Z M6,3 L6,17 L19,17 L19,3 L6,3 Z M8,5 L8,15 L17,15 L17,5 L8,5 Z M6,18 L6,23 L19,23 L19,18 L6,18 Z M8,20 L8,23 L17,23 L17,20 L8,20 Z"
					id="shape"
				/>
			</g>
		</g>
	</svg>
);

export const LayoutGridTwoColumn = () => (
	<svg
		width="18px"
		height="17px"
		viewBox="0 0 18 17"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>layout-grid-2-column</title>
		<desc>Created with Sketch.</desc>
		<g
			id="Desktop-0.4"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="widgets/layout-gird-2-col"
				transform="translate(-3.000000, -3.000000)"
				fill="#000000"
			>
				<path
					d="M11,12 L11,20 L3,20 L3,12 L11,12 Z M21,12 L21,20 L13,20 L13,12 L21,12 Z M9,14 L5,14 L5,18 L9,18 L9,14 Z M19,14 L15,14 L15,18 L19,18 L19,14 Z M11,3 L11,11 L3,11 L3,3 L11,3 Z M21,3 L21,11 L13,11 L13,3 L21,3 Z M9,5 L5,5 L5,9 L9,9 L9,5 Z M19,5 L15,5 L15,9 L19,9 L19,5 Z"
					id="Shape"
				/>
			</g>
		</g>
	</svg>
);

export const LayoutGridThreeColumn = () => (
	<svg
		width="20px"
		height="13px"
		viewBox="0 0 20 13"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>layout-grid-3-column</title>
		<desc>Created with Sketch.</desc>
		<g
			id="Desktop-0.4"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="widgets/layout-gird-3-col"
				transform="translate(-2.000000, -5.000000)"
				fill="#000000"
			>
				<path
					d="M8,12 L8,18 L2,18 L2,12 L8,12 Z M15,12 L15,18 L9,18 L9,12 L15,12 Z M22,12 L22,18 L16,18 L16,12 L22,12 Z M6,14 L4,14 L4,16 L6,16 L6,14 Z M13,14 L11,14 L11,16 L13,16 L13,14 Z M20,14 L18,14 L18,16 L20,16 L20,14 Z M8,5 L8,11 L2,11 L2,5 L8,5 Z M15,5 L15,11 L9,11 L9,5 L15,5 Z M22,5 L22,11 L16,11 L16,5 L22,5 Z M6,7 L4,7 L4,9 L6,9 L6,7 Z M13,7 L11,7 L11,9 L13,9 L13,7 Z M20,7 L18,7 L18,9 L20,9 L20,7 Z"
					id="Combined-Shape"
				/>
			</g>
		</g>
	</svg>
);

export const LayoutClassic = () => (
	<svg
		width="17px"
		height="14px"
		viewBox="0 0 17 14"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>layout-classic</title>
		<desc>Created with Sketch.</desc>
		<g
			id="Desktop-0.4"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="widgets/layout-classic"
				transform="translate(-3.000000, -5.000000)"
				fill="#000000"
			>
				<path
					d="M3,12 L6,12 L6,9 L3,9 L3,12 Z M3,16 L6,16 L6,13 L3,13 L3,16 Z M3,8 L6,8 L6,5 L3,5 L3,8 Z M7,5 L7,19 L20,19 L20,5 L7,5 Z M9,7 L9,17 L18,17 L18,7 L9,7 Z"
					id="shape"
				/>
			</g>
		</g>
	</svg>
);

export const ShapeRound = () => (
	<svg
		width="18px"
		height="18px"
		viewBox="0 0 18 18"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>shape-round</title>
		<desc>Created with Sketch.</desc>
		<g
			id="Desktop-0.4"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="widgets/shape-round"
				transform="translate(-3.000000, -3.000000)"
				fill="#000000"
			>
				<path
					d="M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,5 C8.13400675,5 5,8.13400675 5,12 C5,15.8659932 8.13400675,19 12,19 C15.8659932,19 19,15.8659932 19,12 C19,8.13400675 15.8659932,5 12,5 Z"
					id="Combined-Shape"
				/>
			</g>
		</g>
	</svg>
);

export const ShapeSquare = () => (
	<svg
		width="18px"
		height="18px"
		viewBox="0 0 18 18"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>ratio-square</title>
		<desc>Created with Sketch.</desc>
		<g
			id="Desktop-0.4"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="widgets/shape-square"
				transform="translate(-3.000000, -3.000000)"
				fill="#000000"
			>
				<path
					d="M3,3 L3,21 L21,21 L21,3 L3,3 Z M5,5 L5,19 L19,19 L19,5 L5,5 Z"
					id="shape"
				/>
			</g>
		</g>
	</svg>
);

export const ShapeRadius = () => (
	<svg
		width="18px"
		height="18px"
		viewBox="0 0 18 18"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>shape-radius</title>
		<desc>Created with Sketch.</desc>
		<g
			id="Desktop-0.4"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="widgets/shape-radius"
				transform="translate(-3.000000, -3.000000)"
				fill="#000000"
			>
				<path
					d="M17,3 C19.209139,3 21,4.790861 21,7 L21,17 C21,19.209139 19.209139,21 17,21 L7,21 C4.790861,21 3,19.209139 3,17 L3,7 C3,4.790861 4.790861,3 7,3 L17,3 Z M17,5 L7,5 C5.9456382,5 5.08183488,5.81587779 5.00548574,6.85073766 L5,7 L5,17 C5,18.0543618 5.81587779,18.9181651 6.85073766,18.9945143 L7,19 L17,19 C18.0543618,19 18.9181651,18.1841222 18.9945143,17.1492623 L19,17 L19,7 C19,5.9456382 18.1841222,5.08183488 17.1492623,5.00548574 L17,5 Z"
					id="Rectangle"
				/>
			</g>
		</g>
	</svg>
);

export const ShapeRectangle = () => (
	<svg
		width="14px"
		height="20px"
		viewBox="0 0 14 20"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>ratio-9-16</title>
		<desc>Created with Sketch.</desc>
		<g
			id="Desktop-0.4"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="ratio/9-16"
				transform="translate(-5.000000, -2.000000)"
				fill="#000000"
			>
				<path
					d="M22,5.5 L22,18.5 L2,18.5 L2,5.5 L22,5.5 Z M20,7.5 L4,7.5 L4,16.5 L20,16.5 L20,7.5 Z"
					id="Combined-Shape"
					transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) "
				/>
			</g>
		</g>
	</svg>
);

export const ShapeNone = () => (
	<svg
		width="18px"
		height="18px"
		viewBox="0 0 18 18"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<title>shape-none</title>
		<desc>Created with Sketch.</desc>
		<g
			id="Desktop-0.4"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="widgets/shape-none"
				transform="translate(-3.000000, -3.000000)"
				fill="#000000"
			>
				<path
					d="M5,19 L5,21 L3,21 L3,19 L5,19 Z M21,19 L21,21 L19,21 L19,19 L21,19 Z M13,19 L13,21 L11,21 L11,19 L13,19 Z M9,19 L9,21 L7,21 L7,19 L9,19 Z M17,19 L17,21 L15,21 L15,19 L17,19 Z M21,15 L21,17 L19,17 L19,15 L21,15 Z M21,11 L21,13 L19,13 L19,11 L21,11 Z M5,11 L5,13 L3,13 L3,11 L5,11 Z M21,7 L21,9 L19,9 L19,7 L21,7 Z M5,7 L5,9 L3,9 L3,7 L5,7 Z M13,3 L13,5 L11,5 L11,3 L13,3 Z M9,3 L9,5 L7,5 L7,3 L9,3 Z M17,3 L17,5 L15,5 L15,3 L17,3 Z M21,3 L21,5 L19,5 L19,3 L21,3 Z M5,3 L5,5 L3,5 L3,3 L5,3 Z M3,15 L5,15 L5,17 L3,17 L3,15 Z"
					id="Shape"
				/>
			</g>
		</g>
	</svg>
);
